/*
** TODO: specifically for IE
 */
import 'es6-promise/auto';
import 'es6-object-assign/auto';
import 'url-search-params-polyfill';
import 'mdn-polyfills/Array.prototype.includes';
import 'mdn-polyfills/Array.prototype.find';
import 'mdn-polyfills/Array.prototype.findIndex';
import 'mdn-polyfills/Number.isInteger';
import 'mdn-polyfills/Object.keys';

import Vue from 'vue';
import VueLodash from 'vue-lodash'
import PortalVue from 'portal-vue';
import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue';

import '@/utils/validator';
import '@/assets/styles/index.scss';
import 'material-design-icons/iconfont/material-icons.css'

import App from '@/App';
import store from '@/store/store';
import router from '@/router/router';
import filters from '@/filters/filters';
import directives from '@/directives/directives';

Vue.use(BootstrapVue);
Vue.use(VueLodash);
Vue.use(PortalVue);
Vue.use(VeeValidate, {
    fieldsBagName: 'field',
    events: 'input'
});

Vue.config.productionTip = false;
export const eventBus = new Vue();
export const PARENT_APP = new Vue({
    el: '#app',
    router,
    store,
    filters,
    directives,
    components: { App },
    template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js